import { takeEvery,  all, fork } from 'redux-saga/effects';
import { PUT_USER } from './action';

export function* onPutUserSaga(user) {
   yield localStorage.setItem('user', JSON.stringify(user.payload));
}

export function* putUserSaga() {
	yield takeEvery(PUT_USER, onPutUserSaga);
}

export function* userSaga() {
	yield all([ fork(putUserSaga) ]);
}
